import gql from 'graphql-tag';

// eslint-disable-next-line import/prefer-default-export
export const LOADER_MUTATION = gql`
  mutation loader($show: Boolean!) {
    loader(show: $show) @client
  }
`;
